import { useRef, type FC } from 'react';
import { graphql, useFragment } from 'react-relay';

import { PdpSharedVimeoVideoLazy } from '../../../shared/PdpSharedVimeoVideo/PdpSharedVimeoVideoLazy.tsx';
import { VideoPlayer } from 'dibs-video/exports/VideoPlayer.ts';
import { useFullscreen } from 'dibs-elements/exports/useFullscreen.tsx';

import dibsCss from 'dibs-css';

import { type VideoContainer_videoVimeo$key } from './__generated__/VideoContainer_videoVimeo.graphql.ts';

const videoVimeoFragment = graphql`
    fragment VideoContainer_videoVimeo on VideoVimeo {
        vimeoId
    }
`;

export const VideoContainer: FC<{
    videoVimeo?: VideoContainer_videoVimeo$key | null;
    vimeoItemsVideoHLSPlayerFF?: boolean;
    videoUrl: string;
    heightOffset?: number;
    paused?: boolean;
    isMobile?: boolean;
    hideControls?: boolean;
}> = ({
    videoVimeo: videoVimeoRef,
    vimeoItemsVideoHLSPlayerFF,
    videoUrl,
    heightOffset,
    paused = false,
    isMobile = false,
    hideControls = false,
}) => {
    const videoVimeoData = useFragment(videoVimeoFragment, videoVimeoRef);
    const videoPlayerRef = useRef<HTMLVideoElement>(null);
    const { handleFullscreenToggle } = useFullscreen(videoPlayerRef);

    if (videoVimeoData?.vimeoId && !vimeoItemsVideoHLSPlayerFF) {
        return (
            <PdpSharedVimeoVideoLazy
                id={videoVimeoData.vimeoId}
                useDefaultControls={!isMobile}
                heightOffset={heightOffset}
                paused={paused}
            />
        );
    } else {
        return (
            <div className={dibsCss.minH0}>
                <VideoPlayer ref={videoPlayerRef}>
                    <VideoPlayer.Media
                        src={videoUrl}
                        playback={{ loop: true, autoPlay: !paused }}
                        callbacks={{
                            onClick: () => {
                                if (videoPlayerRef.current && isMobile) {
                                    handleFullscreenToggle();
                                }
                            },
                        }}
                    />
                    {!hideControls && <VideoPlayer.Logo />}
                    {!isMobile && !hideControls && <VideoPlayer.Controls />}
                </VideoPlayer>
            </div>
        );
    }
};
